import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["mode", "external", "native"]
  connect() { this.refresh() }
  refresh() {
    const external = (this.modeTargets.find(input => input.tagName === "SELECT" || input.checked)?.value) === "external"
    if (this.hasExternalTarget) {
      this.externalTarget.hidden = !external
      const url = this.externalTarget.querySelector("input[type=url]")
      if (url) { url.required = external; url.disabled = !external }
    }
    if (this.hasNativeTarget) this.nativeTarget.hidden = external
  }
}
